import { render } from "./CreateBuildingForm.vue?vue&type=template&id=43a698bf"
import script from "./CreateBuildingForm.vue?vue&type=script&lang=js"
export * from "./CreateBuildingForm.vue?vue&type=script&lang=js"

import "./CreateBuildingForm.vue?vue&type=style&index=0&id=43a698bf&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "43a698bf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43a698bf', script)) {
    api.reload('43a698bf', script)
  }
  
  module.hot.accept("./CreateBuildingForm.vue?vue&type=template&id=43a698bf", () => {
    api.rerender('43a698bf', render)
  })

}

script.__file = "src/components/dashboard/CreateBuildingForm.vue"

export default script